var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactaFinanceira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 64,
    viewBox: "0 0 72 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6079_2604)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4253 40.8901V39.9117C16.4253 39.5743 16.2898 39.4393 15.9511 39.4393H12.937C12.5984 39.4393 12.4629 39.5743 12.4629 39.9117V40.8901H13.5466V40.6202C13.5466 40.519 13.6143 40.4515 13.7159 40.4515H13.8514V44.3651H15.1045V40.4852H15.2399C15.3415 40.4852 15.4093 40.5527 15.4093 40.6539V40.9238H16.4253V40.8901Z",
    fill: "#0A6D99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60602 39.4393L3.08203 44.3988H3.69163C4.06416 44.3988 4.19962 44.2976 4.30122 43.994L5.28335 40.7214L5.75748 42.3746H5.31721L4.53829 43.3867H6.02841L6.26547 44.0277C6.36707 44.3314 6.50254 44.4326 6.87507 44.4326H7.48467L5.96068 39.4731H4.60602V39.4393Z",
    fill: "#0A6D99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9654 39.4393H17.6446L16.1206 44.3988H16.7302C17.1027 44.3988 17.2382 44.2976 17.3398 43.994L18.3219 40.7214L18.7961 42.3746H18.3558L17.5769 43.3867H19.067L19.304 44.0277C19.4056 44.3314 19.5411 44.4326 19.9136 44.4326H20.5232L18.9654 39.4393Z",
    fill: "#0A6D99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25306 40.4852H2.13358C2.23518 40.4852 2.30292 40.5526 2.30292 40.6539V40.9238H3.38664V39.9791C3.38664 39.6417 3.21731 39.473 2.87865 39.473H0V44.4325H1.25306V43.3867H1.69332L2.50611 42.3408H1.25306V40.4852Z",
    fill: "#0A6D99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1598 43.3192C9.41472 43.3192 8.839 42.6782 8.839 41.8685C8.839 40.9575 9.41472 40.5189 10.1598 40.5189C10.4646 40.5189 10.9387 40.6201 10.9387 40.9238H12.0563V40.5189C12.0563 39.608 10.7355 39.3718 10.1598 39.3718C8.66966 39.3718 7.58594 40.4514 7.58594 41.8685C7.58594 43.2855 8.6358 44.4663 10.1937 44.4663C11.5144 44.4663 12.2595 43.5891 12.2595 43.5891L11.616 42.7119C11.5822 42.7119 11.0403 43.3192 10.1598 43.3192Z",
    fill: "#0A6D99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0114 39.4393H22.0811V44.3988H22.5891V42.1721H23.876V41.7335H22.5891V39.8779H23.8421C23.9437 39.8779 24.0114 39.9117 24.0114 40.0466V40.384H24.4856V39.8779C24.4517 39.5743 24.3162 39.4393 24.0114 39.4393Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7377 43.994C43.6201 43.994 42.7734 43.0493 42.7734 41.8685C42.7734 40.6876 43.6201 39.8104 44.7377 39.8104C45.3134 39.8104 46.1262 40.0803 46.1262 40.5189V40.7888H46.6004V40.4177C46.6004 39.6755 45.4489 39.3718 44.7377 39.3718C43.3492 39.3718 42.2993 40.4514 42.2993 41.9022C42.2993 43.3529 43.3153 44.5 44.7716 44.5C45.9908 44.5 46.6681 43.6903 46.6681 43.6903L46.3972 43.3192C46.3633 43.3192 45.7537 43.994 44.7377 43.994Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1108 39.4393H25.6367V44.3651H26.1108V39.4393Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7481 39.4393H51.2739V44.3651H51.7481V39.4393Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8523 39.8779V43.5891C30.7846 43.4879 27.9398 39.4731 27.9398 39.4731H27.4995V43.7916V44.3651H27.5672C27.872 44.3651 28.0075 44.2302 28.0075 43.9265V40.2153C28.0752 40.3165 30.92 44.3314 30.92 44.3314H31.3603V39.4393H31.3264C30.9539 39.4393 30.8523 39.5743 30.8523 39.8779Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7414 39.8779V43.5891C40.6737 43.4879 37.8289 39.4731 37.8289 39.4731H37.3887V43.7916V44.3651H37.4564C37.7612 44.3651 37.8967 44.2302 37.8967 43.9265V40.2153C37.9644 40.3165 40.8092 44.3314 40.8092 44.3314H41.2494V39.4393H41.2156C40.8769 39.4393 40.7414 39.5743 40.7414 39.8779Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6482 39.4393H47.7178V44.3988H49.682C49.9868 44.3988 50.1223 44.2639 50.1223 43.9602V43.4542H49.6482V43.7916C49.6482 43.8928 49.5804 43.9602 49.4788 43.9602H48.2258V42.1721H49.5127V41.7335H48.2258V39.8779H49.4788C49.5804 39.8779 49.6482 39.9117 49.6482 40.0466V40.384H50.1223V39.8779C50.0884 39.5743 49.953 39.4393 49.6482 39.4393Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1711 39.4393L32.5455 43.7916L32.3423 44.3651H32.4439C32.7825 44.3651 32.8841 44.2976 33.0196 43.9602L34.442 39.9454L35.2887 42.3408H33.7985L33.4599 42.7794H35.4241L35.8644 43.9602C35.9999 44.2976 36.1015 44.3651 36.4401 44.3651H36.5417L34.7129 39.4393H34.1711Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3003 39.4393H58.7923L57.1329 43.7916L56.9297 44.3651H57.0313C57.3699 44.3651 57.4716 44.2976 57.607 43.9602L59.0294 39.9454L59.8761 42.3408H58.3859L58.0473 42.7794H60.0115L60.4518 43.9602C60.5873 44.2976 60.6889 44.3651 61.0275 44.3651H61.1291L59.3003 39.4393Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9472 43.7916L55.236 42.3746C55.1683 42.2396 55.0667 42.1721 55.0667 42.1721C55.5408 42.0709 56.0149 41.6323 56.0149 40.8563C56.0149 40.0129 55.4392 39.4393 54.5926 39.4393H52.9331V39.8779V44.3988H53.4411V39.8779H54.5587C55.1344 39.8779 55.507 40.249 55.507 40.8563C55.507 41.4636 55.1344 41.8685 54.5587 41.8685H53.8136L53.475 42.3071H54.2878C54.5587 42.3071 54.6603 42.3408 54.7958 42.6107L55.507 44.0277C55.6763 44.3651 55.7779 44.3988 56.1843 44.3988H56.252C56.1843 44.2639 56.0827 44.0615 55.9811 43.859C55.9472 43.8253 55.9472 43.7916 55.9472 43.7916Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6631 39.4393H68.3423L66.8184 44.3988H67.428C67.8005 44.3988 67.9359 44.2976 68.0375 43.994L69.0197 40.7214L69.4938 42.3746H69.0535L68.2746 43.3867H69.7647L70.0018 44.0277C70.1034 44.3314 70.2389 44.4326 70.6114 44.4326H71.221L69.6631 39.4393Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0593 42.7793C63.0593 42.7793 63.6012 43.2854 64.2446 43.2854C64.4817 43.2854 64.7526 43.1842 64.7526 42.8805C64.7526 42.307 62.5513 42.307 62.5513 40.8225C62.5513 39.9116 63.2964 39.338 64.2785 39.338C65.3284 39.338 65.8702 39.8778 65.8702 39.8778L65.3622 40.8562C65.3622 40.8562 64.8542 40.4176 64.2785 40.4176C64.0414 40.4176 63.7705 40.5188 63.7705 40.7888C63.7705 41.396 65.9718 41.2948 65.9718 42.8468C65.9718 43.6565 65.3622 44.365 64.2446 44.365C63.127 44.365 62.4497 43.6565 62.4497 43.6565L63.0593 42.7793Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1074 44.365C66.257 44.365 66.3783 44.2442 66.3783 44.0951C66.3783 43.946 66.257 43.8252 66.1074 43.8252C65.9577 43.8252 65.8364 43.946 65.8364 44.0951C65.8364 44.2442 65.9577 44.365 66.1074 44.365Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7289 44.365C71.8786 44.365 71.9999 44.2442 71.9999 44.0951C71.9999 43.946 71.8786 43.8252 71.7289 43.8252C71.5793 43.8252 71.458 43.946 71.458 44.0951C71.458 44.2442 71.5793 44.365 71.7289 44.365Z",
    fill: "#EE7B36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4938 33.6026C34.2389 32.6917 34.6114 30.2963 34.9839 28.0695C35.0855 27.361 35.221 26.6863 35.3226 26.0453H33.2229L33.9002 25.3368H35.4581C35.5258 24.9994 35.5935 24.6957 35.6951 24.4596C36.2709 22.604 37.6594 20.9845 39.4882 20.276C37.8287 19.5 35.9322 19.2976 34.1373 19.7025C32.3424 20.1073 30.7506 21.1195 29.5653 22.5365C28.4139 23.9535 27.7365 25.7079 27.7027 27.5635C27.6688 29.3853 28.2107 31.2072 29.2944 32.6917C30.2426 33.94 32.3085 35.1208 33.4938 33.6026Z",
    fill: "url(#paint0_linear_6079_2604)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4008 22.5365C41.5203 21.4906 39.7254 20.6471 38.6416 21.8617C38.032 22.5365 37.7272 23.8523 37.4563 25.3705H41.1139L40.335 26.2477C40.335 26.2477 39.0819 26.1127 37.3547 26.1127H36.0001L37.2531 26.7538C36.8129 29.3516 36.3049 32.2193 34.6454 34.0075C34.3067 34.3786 33.9342 34.6822 33.5278 34.9521C33.2569 35.1208 32.986 35.2558 32.6812 35.3907C34.3745 36.133 36.3049 36.3017 38.0998 35.8293C39.8947 35.357 41.5203 34.3111 42.6379 32.8266C43.7555 31.3422 44.3651 29.5203 44.3312 27.6647C44.2635 25.7416 43.5861 23.9535 42.4008 22.5365Z",
    fill: "url(#paint1_linear_6079_2604)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6079_2604",
    x1: 29.0065,
    y1: 33.0493,
    x2: 35.9874,
    y2: 18.6459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E9AC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE7B36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6079_2604",
    x1: 42.35,
    y1: 22.415,
    x2: 36.7277,
    y2: 36.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F7BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6D99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6079_2604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 25,
    fill: "white",
    transform: "translate(0 19.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactaFinanceira);
export default __webpack_public_path__ + "static/media/facta-financeira.933f06c9d491b770f9d2eb16861c99f3.svg";
export { ForwardRef as ReactComponent };